import isNil from 'lodash/isNil'
import isUndefined from 'lodash/isUndefined'

export const isNilOrUndef = (v: any) => isNil(v) || isUndefined(v)
